import React, { Component } from 'react';
import {
  Form,
  Header,
  Button,
  Message,
  List,
} from 'semantic-ui-react';
import axios from 'axios';
import passwordValidation from './helpers/_passwordValidation';

export default class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        current_password: '',
        password: '',
        confirmed_password: '',
      },
      loading: false,
      errors: {
        messages: [],
        fields: [],
      },
      reqResponse: null,
    }

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleChange(e) {
    const { errors } = this.state;
    const fieldName = e.target.name;
    const data = { ...this.state.data };

    data[fieldName] = e.target.value;
    this.setState({ data });

    if (errors.fields.includes(fieldName)) {
      const validator = passwordValidation(data);
      this.setState({ errors: validator });
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const { data } = this.state;
    const validation = passwordValidation(data);

    this.setState({ errors: validation });

    if (validation.messages.length === 0) {
      this.setState({ loading: true });

      // do api call
      axios.post('/change-password/', data)
        .then((res) => {
          this.setState({
            loading: false,
            reqResponse: {
              success: true,
              header: 'Success',
              content: 'Your password was changed',
            },
            data: {
              current_password: '',
              password: '',
              confirmed_password: '',
            },
          });
        })
        .then(() => {
          setTimeout(() => {
            this.setState({
              reqResponse: null,
            });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            loading: false,
            reqResponse: {
              success: false,
              header: 'There was a problem',
              content: err.response.data.ui_message,
            }
          });

          setTimeout(() => {
            this.setState({
              reqResponse: null,
            });
          }, 3000);
        })
    }
  }

  render() {
    const {
      data,
      loading,
      errors,
      reqResponse,
    } = this.state;

    const errorList = errors.messages.map(x => x.message);
    const invalidFields = errors.fields;
    let formError = false;

    if (errors.messages.length > 0) {
      formError = true;
    }

    return (
      <div>
        <Header
          content="Change Password"
          subheader="Change your password"
          as="h1"
          dividing
        />
        {
          reqResponse
            ? (
                <Message
                  header={reqResponse.header}
                  positive={reqResponse.success ? true : false}
                  error={!reqResponse.success ? true : false}
                  content={reqResponse.content}
                  icon={reqResponse.success ? 'check' : 'exclamation'}
                />
              )
            : null
        }
        <Form error={formError} loading={loading}>
          <Message
            error
            header="Problems"
            negative
            list={errorList}
          />
          <Form.Input
            type="password"
            value={data.current_password}
            name="current_password"
            label="Current Password"
            onChange={this.handleChange}
            error={invalidFields.includes('current_password')}
            required
            width={6}
          />
          <Form.Input
            type="password"
            value={data.password}
            name="password"
            label="New Password"
            onChange={this.handleChange}
            error={invalidFields.includes('password')}
            required
            width={6}
          />
          <Form.Input
            type="password"
            value={data.confirmed_password}
            name="confirmed_password"
            label="New Password Confirmation"
            onChange={this.handleChange}
            error={invalidFields.includes('confirmed_password')}
            required
            width={6}
          />
          <Button
            content="Save New Password"
            onClick={this.onSubmit}
            primary
          />
        </Form>
      </div>
    );
  }
}
